import styled from 'styled-components';

import { SmallParagraph } from '../../../foundations/typefaces/SmallParagraph';

export const StyledSmallParagraph = styled(SmallParagraph)(
  ({ theme: { color, size } }) => ({
    color: color.content.premium.default(),
    padding: `0 0 0 ${size.units(1)}`,
  }),
);

export const TextWrapper = styled.div(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const HorizontalWrapper = styled.div(({ theme: { size } }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexWrap: 'wrap',
  gap: size.units(1.5),

  [StyledSmallParagraph]: {
    textAlign: 'left',
  },
}));
